import { useEffect, useState } from 'react';

interface ExamTimerProps {
  durationMinutes: number;
  onTimeUp: () => void;
  paused?: boolean;
}

export function ExamTimer({ durationMinutes, onTimeUp, paused = false }: ExamTimerProps) {
  const [secondsLeft, setSecondsLeft] = useState(durationMinutes * 60);

  useEffect(() => {
    if (secondsLeft <= 0) {
      onTimeUp();
      return;
    }

    if (paused) return;

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onTimeUp();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [secondsLeft, onTimeUp, paused]);

  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor((secondsLeft % 3600) / 60);
  const seconds = secondsLeft % 60;
  const isWarning = secondsLeft < 300; // Less than 5 minutes

  const formatDigit = (n: number) => String(n).padStart(2, '0');

  return (
    <div className={`flex items-center gap-1.5 font-mono font-bold tabular-nums ${isWarning ? 'text-destructive animate-pulse' : 'text-foreground'}`}>
      <svg className="w-4 h-4 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span className="text-base lg:text-lg">{formatDigit(hours)}:{formatDigit(minutes)}:{formatDigit(seconds)}</span>
    </div>
  );
}
